export default function ColumnInfoContent({ title, tooltip, formula }) {
    return (
        <div className="flex flex-col gap-2" style={{ maxWidth: 260 }}>
            {title && <p className="text-sm font-semibold text-gray-900">{title}</p>}
            <p className="text-sm text-gray-700 leading-snug">{tooltip}</p>
            {formula && (
                <p className="font-mono text-xs bg-gray-100 rounded-sm px-2 py-1.5 text-gray-600 leading-snug">
                    ƒ &nbsp;{formula}
                </p>
            )}
        </div>
    )
}
